import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';

const ModuleNotAvailable = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center bg-background p-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center">
            <Icon name="Construction" size={40} className="text-muted-foreground" />
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-foreground mb-2">
          {t('moduleNotAvailable.title')}
        </h1>
        <p className="text-muted-foreground mb-6">
          {t('moduleNotAvailable.message')}
        </p>
        <Button
          variant="primary"
          iconName="ArrowLeft"
          iconPosition="left"
          onClick={() => navigate('/dashboard')}
        >
          {t('moduleNotAvailable.backToDashboard')}
        </Button>
      </div>
    </div>
  );
};

export default ModuleNotAvailable;
